import { entityHref } from '../../Capture/record/entityRoutes';
import { holderLabel, yearOf } from './seatTime';
const sameHolder = (a, b)=>a.holderCompanyId && b.holderCompanyId ? a.holderCompanyId === b.holderCompanyId : holderLabel(a) === holderLabel(b);
/** Deterministic "What changed" rows (GRW-25 item 7). Facts only: hearsay is never used here. Newest first. */ export function whatChanged(seats) {
    const out = [];
    const byId = new Map(seats.map((s)=>[
            s.id,
            s
        ]));
    for (const s of seats){
        const rounds = s.rounds.filter((r)=>r.status !== 'future').sort((a, b)=>a.popStart.localeCompare(b.popStart));
        for(let i = 1; i < rounds.length; i++){
            const prev = rounds[i - 1];
            const next = rounds[i];
            if (sameHolder(prev, next)) continue;
            const until = yearOf(prev.popEnd || next.popStart);
            const since = yearOf(next.popStart);
            const programHref = next.programId ? entityHref('program', next.programId) : null;
            const link = programHref ? {
                label: 'Program',
                href: programHref
            } : undefined;
            if (next.holderKind === 'us' && since !== null) {
                out.push({
                    id: `${next.id}:won`,
                    year: since,
                    text: `${s.name}: we took it from ${holderLabel(prev)} in ${since}.`,
                    link
                });
            } else if (until !== null) {
                out.push({
                    id: `${next.id}:change`,
                    year: until,
                    text: `${s.name}: ${holderLabel(prev)} held it until ${until}, then ${holderLabel(next)} won it.`,
                    link
                });
            }
        }
        for (const p of s.pursuits){
            const y = yearOf(p.endedAt);
            if (p.outcome !== 'lost' || y === null) continue;
            const href = entityHref('pursuit', p.captureProjectId);
            out.push({
                id: `${s.id}:${p.captureProjectId}:lost`,
                year: y,
                text: `We lost the ${s.name} seat in ${y}.`,
                link: href ? {
                    label: 'Thread',
                    href
                } : undefined
            });
        }
        const merged = yearOf(s.mergedOn);
        if (s.mergedIntoSeatId && merged !== null) out.push({
            id: `${s.id}:merge`,
            year: merged,
            text: `${merged}: ${s.name} merged into ${byId.get(s.mergedIntoSeatId)?.name ?? s.mergedIntoSeatId}.`
        });
        const split = yearOf(s.splitOn);
        if (s.splitFromSeatId && split !== null) {
            const parent = byId.get(s.splitFromSeatId)?.name ?? 'A seat';
            out.push({
                id: `${s.id}:split`,
                year: split,
                text: `${split}: ${parent} split into a new seat, ${s.name}.`
            });
        }
    }
    return out.sort((a, b)=>b.year - a.year);
}
